import React, { PropsWithChildren } from "react";
import * as RadixContextMenu from "@radix-ui/react-context-menu";
import styled from "styled-components";

const StyledContextMenuContent = styled(RadixContextMenu.Content)`
  background-color: ${({ theme }) => theme.colors.backgroundElevated2};
  width: 240px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.border};
  border-radius: 6px;
  padding: ${({ theme }) => theme.spacing.spacing3.toString()}
    ${({ theme }) => theme.spacing.spacing2.toString()};
  box-shadow: 0 8px 20px 0 #0000000a;
  z-index: 40;
`;

interface ContextMenuProps extends PropsWithChildren {
  readonly onOpenChange?: (open: boolean) => void;
}

export function ContextMenu({ children, onOpenChange }: ContextMenuProps): React.JSX.Element {
  const [contextMenuTrigger, contextMenuItems] = React.Children.toArray(children);
  return (
    <RadixContextMenu.Root onOpenChange={onOpenChange}>
      <RadixContextMenu.Trigger>{contextMenuTrigger}</RadixContextMenu.Trigger>
      <RadixContextMenu.Portal>
        <StyledContextMenuContent onCloseAutoFocus={(e) => e.preventDefault()}>
          {contextMenuItems}
        </StyledContextMenuContent>
      </RadixContextMenu.Portal>
    </RadixContextMenu.Root>
  );
}
